import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { initDatadog } from '@cartwhl/tracking/datadog';
import { authStore } from 'stores/global';

authStore.init();

const disambiguator = import.meta.env.VITE_API_DISAMBIGUATOR ?? 'unknown';
const env = disambiguator === '' ? 'prod' : disambiguator;

initDatadog({
  service: 'homepage',
  env,
  isDevelopment: process.env.NODE_ENV === 'development',
});

hydrateRoot(
  document,
  <StrictMode>
    <HydratedRouter />
  </StrictMode>,
);
